<template>
  <div class="ai-interview-container">
    <InfoCard
      icon="iconfont icona-jobname"
      :title="$t(`${i18nPrefix}.title.aiInterview`)"
      :infoList="infoList"
      :hiddenIcon="hiddenIcon"
      :hiddenTitle="hiddenTitle"
    >
      <template #infoLine>
        <div class="info-line">
          <div class="score line">
            <div class="label">{{ $t(`${i18nPrefix}.label.overallScore`) }}</div>
            <slot v-if="isCustomScore" v-bind="{ totalScore }" name="score"></slot>
            <div v-else class="value">{{ isAllFinished ? ([null, undefined].includes(totalScore) ? $t(`${i18nPrefix}.message.processQuestionAnswer`) : totalScore) : '-' }}</div>
          </div>
          <div class="pdf line">
            <div class="label">{{ $t(`${i18nPrefix}.label.interviewReport`) }}</div>
            <slot v-if="isCustomReportUrl" v-bind="{ pdfUrl }" name="report"></slot>
            <div v-else>
              <div v-if="isAllFinished" class="value" :class="pdfUrl && 'link'" @click="downloadReport">{{ (pdfUrl && $t(`${i18nPrefix}.label.clickToView`)) || $t(`${i18nPrefix}.message.processQuestionAnswer`) }}</div>
              <div v-else class="value">-</div>
            </div>
          </div>
        </div>
        <div class="info-line">
          <div class="finish-time line">
            <div class="label">{{ $t(`${i18nPrefix}.label.aiInterviewTime`) }}</div>
            <div class="value">{{ finishedTime|empty }}</div>
          </div>
        </div>
        <slot v-if="isCustomQuestion" v-bind="{questionList}" name="question"></slot>
        <template v-else>
          <div v-for="(item, index) in questionList" class="info-line" :key="index" :class="item.answer || 'no-answer'">
            <div class="question line">
              <div class="label">{{ $t(`${i18nPrefix}.label.questions`) }}</div>
              <div class="value">{{ item.question_title }}</div>
            </div>
            <div class="video line">
              <div class="label">{{ $t(`${i18nPrefix}.label.video`) }}</div>
              <div class="value video-container" @click="onVideoContainerClick(item)">
                <img v-if="item.answer" class="video-play-icon" :src="$DjangoStaticUrl('image/video/icon_video.png')"/>
                <div v-else v-rect-loading="item.uploading" class="upload-btn">
                  <span class="btn-label">{{ $t('common.btn.clickToUpload') }}</span>
                </div>
              </div>
              <input v-if="!item.answer && !isDisabled" class="upload-input" type="file" accept=".mp4" :ref="`uploader_${item.question_id}`" @change="onVideoChange(item)"/>
            </div>
          </div>
        </template>
      </template>
    </InfoCard>
    <DialogWrapper
      hideFooter
      class="video-player-dialog"
      :title="popInfo.title"
      :show.sync="popInfo.showVideoPop"
      @close="closeVideoDialog"
    >
      <div class="video-player-container">
        <video
          v-if="popInfo.showVideoPop && popInfo.videoUrl"
          controls
          autoplay
          ref="videoPlayer"
          class="video"
          width="375"
          :src="popInfo.videoUrl"
        ></video>
      </div>
    </DialogWrapper>
  </div>
</template>

<script>
import InfoCard from '@/components/candidate/infoCard.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import { addQueryInPath } from '@/utils/common'
import { uploadFile } from '@/utils/qiniu'
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  components: {
    InfoCard,
    DialogWrapper
  },
  props: {
    candidateBaseInfo: {
      required: true
    },
    questionList: {
      type: Array,
      default: () => []
    },
    totalScore: {
      type: Number
    },
    pdfUrl: {
      type: String
    },
    finishedTime: {
      type: String
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isCustomScore: {
      type: Boolean,
      default: false
    },
    isCustomReportUrl: {
      type: Boolean,
      default: false
    },
    isCustomQuestion: {
      type: Boolean,
      default: false
    },
    hiddenIcon: {
      type: Boolean,
      default: false
    },
    hiddenTitle: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      popInfo: {
        showVideoPop: false,
        title: null,
        videoUrl: null
      }
    }
  },
  computed: {
    infoList () {
      return [{}]
    },
    infoLines () {
      const lines = {
      }
      return lines
    },
    isAllFinished () {
      let finished = true
      _.forEach(this.questionList, question => {
        if (!question.answer) {
          finished = false
        }
      })
      return finished
    }
  },
  created () {

  },
  methods: {
    ...mapActions('common', ['getPrivateFileUrl']),
    ...mapActions('interview', ['updateCoachAIInterviewAnswer']),
    onVideoContainerClick (question) {
      if (question.answer) {
        this.openVideoDialog(question)
      } else {
        this.onUploadVideoBtnClick(question)
      }
    },
    async openVideoDialog (question) {
      const resp = await this.getPrivateFileUrl({ fileType: 'COMMON_FILE', fileKey: question.answer })
      const popInfo = this.popInfo
      popInfo.title = question.question_title
      popInfo.videoUrl = resp
      popInfo.showVideoPop = true
    },
    onUploadVideoBtnClick (question) {
      if (this.isDisabled) {
        return
      }
      if (question.uploading) {
        return
      }
      const ref = this.$refs[`uploader_${question.question_id}`][0]
      ref.click()
    },
    onVideoChange (question) {
      if (this.isDisabled) {
        return
      }
      const ref = this.$refs[`uploader_${question.question_id}`][0]
      const file = ref.files && ref.files[0]
      if (!file) {
        return
      }
      this.$set(question, 'uploading', true)
      this.uploadQuestionVideo(question, file)
    },
    fileKeyGenerator (candidateId, questionId) {
      return `interview/coach_7090/answer/${candidateId}/${questionId}/${new Date().valueOf()}.mp4`
    },
    uploadQuestionVideo (question, videoFile) {
      const candidateId = this.candidateBaseInfo.id
      const questionId = question.question_id
      const fileKey = this.fileKeyGenerator(candidateId, questionId)
      uploadFile(videoFile, fileKey, false).then(() => this.updateCoachAIInterviewAnswer({
        candidateId: candidateId,
        answerInfo: {
          question_id: questionId,
          answer: fileKey
        }
      })).then((resp) => {
        if (resp.is_finished && resp.finished_time) {
          this.$emit('update-finished-time', resp)
        }
        this.$message.success(this.$t(`${this.i18nPrefix}.message.uploadVideoSuccess`))
        question.answer = fileKey
      }).catch(() => {
        this.$message.error(this.$t(`${this.i18nPrefix}.message.uploadVideoFail`))
      }).finally(() => {
        const refs = this.$refs[`uploader_${question.question_id}`]
        if (refs) {
          const ref = refs[0]
          ref.value = null
        }
        question.uploading = false
      })
    },
    closeVideoDialog () {
      this.popInfo.showVideoPop = false
      this.popInfo.title = null
      this.popInfo.videoUrl = null
    },
    pauseVideo () {
      const player = this.$refs.videoPlayer
      if (player) {
        player.pause()
      }
    },
    async downloadReport () {
      if (!this.pdfUrl) {
        return
      }
      const pdfUrl = await this.getPrivateFileUrl({ fileType: 'COMMON_FILE', fileKey: this.pdfUrl })
      // pdf文件名: 公司名称_候选人名称_候选人ID_20230920.pdf
      const baseInfo = this.candidateBaseInfo
      const companyName = baseInfo.company.i18nName
      const candidateName = baseInfo.other_name
      const candidateId = baseInfo.id
      const fileName = `${companyName}_${candidateName}_${candidateId}_${moment().format('YYYYMMDD')}.pdf`
      const url = addQueryInPath(pdfUrl, {
        attname: fileName
      })
      window.location.href = url
    }
  },
  watch: {
    'popInfo.showVideoPop' () {
      if (!this.popInfo.showVideoPop) {
        this.pauseVideo()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ai-interview-container {
  .info-line {
    .line {
      & + .line {
        margin-top: 20px;
      }

      .label {
        color: #303133;
        font-weight: bold;
      }

      .value {
        margin-top: 3px;
        color: #606266;
        white-space: pre-wrap;

        &.link {
          color: #0096cc;
          text-decoration: underline;
          cursor: pointer;

          &.is-disabled {
            color: #c0c4cc;
            cursor: not-allowed;
          }
        }

        &.video-container {
          flex: initial;
          position: relative;
          width: 164px;
          height: 78px;
          cursor: pointer;
          background-image: url($baseDomain + 'static/image/video/video_bg.png');
          background-size: 100% 100%;

          .video-play-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 40px;
            height: 40px;
            transform: translate(-50%, -50%);
          }
        }
      }
    }

    &.no-answer {
      .question {
        .value {
          color: #f56c6c;
        }
      }

      .video {
        .video-container {
          border: 1px dashed #c0ccda;
          border-radius: 6px;
          background: #fbfdff;
          text-align: center;

          &:hover {
            border-color: #0096cc;
          }

          .upload-btn {
            height: 100%;

            .btn-label {
              line-height: 78px;
            }
          }
        }

        .upload-input {
          display: none;
        }
      }
    }
  }

  .video-player-dialog {
    ::v-deep .el-dialog__body {
      height: 60vh;
    }

    .video-player-container {
      height: calc(100% - 50px);
      text-align: center;

      .video {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
